// import { users } from "../misc/client";
// import GenericCRUD from "./GenericCRUD";

// export const AdminUserSystem = () => (
//   <GenericCRUD
//     title="User"
//     canCreate={false}
//     api={users}
//     columns={[
//       { key: "name", label: "Name" },
//       { key: "email", label: "Email" },
//       {
//         key: "group",
//         label: "Group",
//         render: (value) =>
//           value === "0"
//             ? "Admin"
//             : value === "100"
//             ? "Maksājumu ievade"
//             : "Lietotājs",
//       },
//     ]}
//     formFields={[
//       { key: "name", label: "Name", required: true },
//       { key: "email", label: "Email", required: true },
//       {
//         key: "group",
//         label: "Group",
//         type: "select",
//         options: [
//           { value: "0", label: "Admin" },
//           { value: "1", label: "Lietotājs" },
//           { value: "100", label: "Maksājumu ievade" },
//         ],
//       },
//     ]}
//     searchFields={["name", "email"]}
//   />
// );

import { users } from "../misc/client";
import GenericCRUD from "./GenericCRUD";

export const AdminUserSystem = () => (
  <GenericCRUD
    title="User"
    canCreate={false}
    api={users}
    columns={[
      { key: "name", label: "Name" },
      { key: "email", label: "Email" },
      {
        key: "group",
        label: "Group",
        render: (value) =>
          value === "0"
            ? "Admin"
            : value === "100"
              ? "Dežurants"
              : "Lietotājs",
      },
    ]}
    formFields={[
      { key: "name", label: "Name", required: true },
      { key: "email", label: "Email", required: true },
      {
        key: "group",
        label: "Group",
        type: "select",
        options: [
          { value: "0", label: "Admin" },
          { value: "1", label: "Lietotājs" },
          { value: "100", label: "Dežurants" },
        ],
      },
    ]}
    searchFields={["name", "email"]}
  />
);